import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type RobinJrAppStore = {
  isRobinJrApp: boolean;
  toggleRobinJrApp: () => void;
  setRobinJrApp: (isRobinJrApp: boolean) => void;
};

export const useRobinJrAppStore = create<RobinJrAppStore>()(
  persist(
    (set) => ({
      isRobinJrApp: false,
      toggleRobinJrApp: () => set((state) => ({ isRobinJrApp: !state.isRobinJrApp })),
      setRobinJrApp: (isRobinJrApp: boolean) => set({ isRobinJrApp }),
    }),
    {
      name: 'robin-jr-app-store',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ isRobinJrApp: state.isRobinJrApp }),
    },
  ),
);

export const useIsRobinJrApp = () => {
  return useRobinJrAppStore((state) => state.isRobinJrApp);
};
